import { render, staticRenderFns } from "./Development.vue?vue&type=template&id=00ccb21c&scoped=true"
import script from "./Development.vue?vue&type=script&lang=ts"
export * from "./Development.vue?vue&type=script&lang=ts"
import style0 from "./Development.vue?vue&type=style&index=0&id=00ccb21c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ccb21c",
  null
  
)

export default component.exports